import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { PageLinkModel } from '../page-link.model';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PageLinkFilterLabel } from '../page-link-filter-label';
import { ICONS_MAP } from '../../../../shared/constnts/icons-map';

@Component({
  selector: 'in-page-links-list',
  templateUrl: './page-links-list.component.html',
  styleUrls: ['./page-links-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageLinksListComponent implements OnInit, OnChanges {
  @Input() pageLinks: PageLinkModel[] = [];
  @Input() resolve: Params = {};
  @Input() isCount = false;
  /**
   * Набор меток, которые нужно фильтровать
   * в виде массива объектов с булевыми значениями
   * true - фильтровать
   * false|undefined - не фильтровать
   * [
   *  {
   *   label: [labelValue],
   *   filter: true|false|undefined
   *  }
   * ]
   *
   * Пример:
   * [
   *  {
   *   label: 'deviceparams'
   *   filter: true;
   *  }
   * ]
   */
  @Input() filterLabels: PageLinkFilterLabel[] = [];
  bindFilterLabels = this.filterByLabels.bind(this);

  protected readonly ICONS_MAP = ICONS_MAP;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit() {
    return;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateLinksCount();
  }

  updateLinksCount() {
    if (!this.isCount) {
      return;
    }
    this.pageLinks.forEach((_pl) => {
      if (_pl.countUrl && (typeof _pl.countUrl === 'string' || Array.isArray(_pl.countUrl))) {
        _pl.count = this.http.get<number>(this.resolveUrl(_pl.countUrl));
      }
    });
  }

  resolveUrl(url: string, status = { result: 'ok' }): string {
    let resolvedUrl = url;
    Object.keys(this.resolve).forEach((_key) => {
      if (this.resolve[_key]) {
        resolvedUrl = resolvedUrl.replace(`:${_key}`, this.resolve[_key]);
      }
    });
    Object.keys(this.route.snapshot.params).forEach((_key) => {
      if (this.route.snapshot.params[_key]) {
        resolvedUrl = resolvedUrl.replace(`:${_key}`, this.route.snapshot.params[_key]);
      }
    });
    Object.keys(this.route.parent.snapshot.params).forEach(
      (_key) =>
        (resolvedUrl = resolvedUrl.replace(`:${_key}`, this.route.parent.snapshot.params[_key]))
    );

    const notResolvedParams = Object.keys(this.resolve).filter(
      (_key) => resolvedUrl.indexOf(`:${_key}`) >= 0
    );
    if (
      notResolvedParams.length > 0 &&
      notResolvedParams[0] !== 'controlprocedureId' &&
      notResolvedParams.length === 1
    ) {
      status.result = 'error';
    }
    return resolvedUrl;
  }

  resolveQueryParams(params: {}): {} {
    if (params) {
      const resolvedparams = {};
      Object.keys(this.resolve).forEach((_key) => {
        if (this.resolve[_key] && params[_key]) {
          resolvedparams[params[_key]] = this.resolve[_key];
        }
      });
      return resolvedparams;
    }
  }

  filterByLabels(data) {
    const status = { result: 'ok' };
    this.resolveUrl(data.url, status);
    if (status.result === 'error') {
      return false;
    }
    return (
      this.filterLabels.find((_filter) => _filter.label === data.label) || {
        label: 'any',
        isShow: true,
      }
    ).isShow;
  }
}
